/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Video/theme';

export const VideoTheme = theme;
